<template>
  <bridged-a role="listitem"
             class="tv-cell tv-cell-subtitle tv-cell-button"
             :href="'/' + wall.address"
             target="_blank"
             bridge-target="padlet"
             data-app-target="blank">
    <div class="tv-cell-thumb" :style="{ background: backgroundStyle }" />
    <div class="tv-cell-text">
      <h3>{{ title }}</h3>
      <div class="small-caption-type">
        <span>{{ wall.builder.display_name }}</span> •
        <relative-time :datetime="wall.updated_at" dateformat="short" />
      </div>
    </div>
    <padlet-card-actions v-if="actions"
                         class="accessory"
                         type="list"
                         :wall="wall" />
  </bridged-a>
</template>

<script>
import { processedUrl } from '@padlet/vivaldi-client'

import BridgedA from 'vuecomponents/bridged_a'
import PadletCardActions from 'vuecomponents/padlet_card_actions'
import { __ } from 'bits/intl'
import RelativeTime from './relative_time'

export default {
  components: { RelativeTime, BridgedA, PadletCardActions },
  props: ['wall', 'actions'],
  computed: {
    title: function () {
      return (this.wall.title || __('Untitled padlet'))
    },
    backgroundStyle: function () {
      const bg = this.wall.background
      const dominantColor = bg.dominant_color || [33, 33, 33]
      const dominantColorAsRgb = `rgb(${dominantColor.join(',')})`
      const backgroundUrl = processedUrl(bg.url, {
        crop: 'thumb',
        width: 56,
        height: 56
      })
      const backgroundImage = `url("${backgroundUrl}")`
      return [backgroundImage, dominantColorAsRgb, 'center/cover'].join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../assets/stylesheets/3/modules/all";

.tv-cell-thumb {
  width: 56px;
  height: 56px;
  box-sizing: border-box;
  border-radius: 8px;
  background-size: cover;
}
.accessory {
  @include directional-margin($margin-right: -16px, $margin-left: 0);
}
</style>
